export const STATE_CODE_MAP: Record<string, string> = {
  // Ko -> Code
  전국: 'all',
  전북특별자치도: '45',
  전라남도: '46',
  전북: '45', // Alternate input
  전남: '46', // Alternate input

  // Code -> Ko
  all: '전국',
  '45': '전북특별자치도',
  '46': '전라남도',
};

export const CITY_EN_MAP: Record<string, string> = {
  // Ko -> En
  전체: 'all',

  // Jeonbuk
  전주시: 'jeonju',
  군산시: 'gunsan',
  익산시: 'iksan',
  정읍시: 'jeongeup',
  남원시: 'namwon',
  김제시: 'gimje',
  완주군: 'wanju',
  진안군: 'jinan',
  무주군: 'muju',
  장수군: 'jangsu',
  임실군: 'imsil',
  순창군: 'sunchang',
  고창군: 'gochang',
  부안군: 'buan',

  // Jeonnam
  목포시: 'mokpo',
  여수시: 'yeosu',
  순천시: 'suncheon',
  나주시: 'naju',
  광양시: 'gwangyang',
  담양군: 'damyang',
  곡성군: 'gokseong',
  구례군: 'gurye',
  고흥군: 'goheung',
  보성군: 'boseong',
  화순군: 'hwasun',
  장흥군: 'jangheung',
  강진군: 'gangjin',
  해남군: 'haenam',
  영암군: 'yeongam',
  무안군: 'muan',
  함평군: 'hampyeong',
  영광군: 'yeonggwang',
  장성군: 'jangseong',
  완도군: 'wando',
  진도군: 'jindo',
  신안군: 'sinan',

  // En -> Ko
  all: '전체',

  // Jeonbuk En -> Ko
  jeonju: '전주시',
  gunsan: '군산시',
  iksan: '익산시',
  jeongeup: '정읍시',
  namwon: '남원시',
  gimje: '김제시',
  wanju: '완주군',
  jinan: '진안군',
  muju: '무주군',
  jangsu: '장수군',
  imsil: '임실군',
  sunchang: '순창군',
  gochang: '고창군',
  buan: '부안군',

  // Jeonnam En -> Ko
  mokpo: '목포시',
  yeosu: '여수시',
  suncheon: '순천시',
  naju: '나주시',
  gwangyang: '광양시',
  damyang: '담양군',
  gokseong: '곡성군',
  gurye: '구례군',
  goheung: '고흥군',
  boseong: '보성군',
  hwasun: '화순군',
  jangheung: '장흥군',
  gangjin: '강진군',
  haenam: '해남군',
  yeongam: '영암군',
  muan: '무안군',
  hampyeong: '함평군',
  yeonggwang: '영광군',
  jangseong: '장성군',
  wando: '완도군',
  jindo: '진도군',
  sinan: '신안군',
};
